import React, { useState } from 'react';
import 'react-image-lightbox/style.css';
import Lightbox from 'react-image-lightbox';
import "./newsevent.css";


import Aimg1 from '../../assets/aimg1.jpg';
import Aimg2 from '../../assets/aimg2.jpg';
import Aimg3 from '../../assets/aimg3.jpg';
import Aimg4 from '../../assets/aimg4.jpg';
import Aimg5 from '../../assets/aimg5.jpg';
import Aimg6 from '../../assets/aimg6.jpg';
import Aimg7 from '../../assets/aimg7.jpg';
import Aimg8 from '../../assets/aimg8.jpg';
import Aimg9 from '../../assets/aimg9.jpg';
import Aimg10 from '../../assets/aimg10.jpg';
import Aimg11 from '../../assets/aimg11.jpg';
import Aimg12 from '../../assets/aimg12.jpg';
import Aimg13 from '../../assets/aimg13.jpg';
import Aimg14 from '../../assets/aimg14.jpg';
import Aimg15 from '../../assets/aimg15.jpg';
import Aimg16 from '../../assets/aimg16.jpg';
import Aimg17 from '../../assets/aimg17.jpg';
import Aimg18 from '../../assets/aimg18.jpg';




const sections = [
  {
   
    images: [Aimg1, Aimg2, Aimg3, Aimg4, Aimg5, Aimg6, Aimg7, Aimg8, Aimg9, Aimg10, Aimg11, Aimg12 , Aimg13, Aimg14, Aimg15, Aimg16 , Aimg17 , Aimg18],
  },
];

const Awurudu = () => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const openViewer = (images, index) => {
    setCurrentImages(images);
    setPhotoIndex(index);
    setIsViewerOpen(true);
  };

  const closeViewer = () => {
    setIsViewerOpen(false);
  };

  return (
    <div className="gallery">
      <h1 align="center">Eye Care Awurudu - 2024</h1>
      <p className="intro-awurudu">The Eye Care Institute proudly celebrated the Sinhala and Hindu New Year with great enthusiasm and joy. It was a wonderful occasion and honor the rich cultural heritage of our community.</p>
      <br />
      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className="gallery-section">
          <div className="gallery-header">
            <h2>{section.title}</h2>
          </div>
          <div className="gallery-grid">
            {section.images.map((src, index) => (
              <div key={index} className="gallery-item">
                <div className="overlay-container">
                <img
                    src={src}
                    alt={`Gallery item ${index + 1} in ${section.title}`} // Avoid the word "image"
                    className="gallery-image"
                    onClick={() => openViewer(section.images, index)}
                  />

                  <div className="overlay">
                    <button
                      className="max-view-button"
                      onClick={() => openViewer(section.images, index)}
                    >
                      <span>&#x2922;</span> {/* Fullscreen icon */}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {isViewerOpen && (
        <Lightbox
          mainSrc={currentImages[photoIndex]}
          nextSrc={currentImages[(photoIndex + 1) % currentImages.length]}
          prevSrc={
            currentImages[
              (photoIndex + currentImages.length - 1) % currentImages.length
            ]
          }
          onCloseRequest={closeViewer}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + currentImages.length - 1) % currentImages.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % currentImages.length)
          }
        />
      )}
    </div>
  );
};
export default Awurudu